const GUEST_SUGGESTION_KEYWORDS = new Set([
  "golfer",
  "foursome",
  "hole",
  "mulligan",
  "tee",
  "cart",
  "putting",
  "pin",
  "golf",
  "scramble",
  "run",
  "walk",
  "pickleball",
  "cornhole",
  "clinic",
  "conference",
  "convention",
  "summit",
  "camp",
  "retreat",
  "tournament",
  "registration",
  "attendee",
  "guest",
  "player",
  "sibling",
  "spectator",
  "coach",
  "waitlist",
  "association",
  "alumni",
  "chapter",
  "foundation",
  "scholarship",
  "leadership",
  "reunion",
  "memorial",
  "banquet",
  "luncheon",
  "awards",
  "anniversary",
  "inaugural",
  "classic",
  "national",
  "youth",
  "celebrating",
  "page",
  "rate",
  "shirt",
  "individuel",
  "journée",
  "édition",
]);

export interface GuestSuggestionCriteria {
  isEventForm: boolean;
  formTexts: string[];
  ticketTypesCount: number;
  hasGroupTickets: boolean;
  hasSeats: boolean;
  hasBuyerCustomQuestions: boolean;
  hasGuestQuestions: boolean;
}

export const containsGuestSuggestionKeyword = (texts: string[]): boolean =>
  texts.some((text) =>
    (text.toLowerCase().match(/[\p{L}\p{N}]+/gu) ?? []).some((word) => GUEST_SUGGESTION_KEYWORDS.has(word))
  );

export const shouldSuggestGuestQuestions = (criteria: GuestSuggestionCriteria): boolean => {
  if (!criteria.isEventForm || !containsGuestSuggestionKeyword(criteria.formTexts)) {
    return false;
  }

  const signals = [
    criteria.ticketTypesCount >= 3,
    criteria.hasGroupTickets,
    criteria.hasSeats,
    criteria.hasBuyerCustomQuestions && !criteria.hasGuestQuestions,
  ];

  return signals.filter(Boolean).length >= 2;
};
